import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection"; // keep eager (LCP)

const AboutSection       = lazy(() => import("@/components/AboutSection"));
const FeaturedProducts   = lazy(() => import("@/components/FeaturedProducts"));
const DiffuserStoneIntro = lazy(() => import("@/components/DiffuserStoneIntro"));
const WhyUseSection      = lazy(() => import("@/components/WhyUseSection"));
const HowToUseSection    = lazy(() => import("@/components/HowToUseSection"));
const FeaturesGrid       = lazy(() => import("@/components/FeaturesGrid"));
const BlogSection        = lazy(() => import("@/components/BlogSection"));
const TestimonialsSection= lazy(() => import("@/components/TestimonialsSection"));
const CTASection         = lazy(() => import("@/components/CTASection"));
const Footer             = lazy(() => import("@/components/Footer"));

import centerImage from "../assets/centerImage-1.webp";

import {
  Gem, Leaf, Hand, Blend, Package, LayoutGrid,
} from "lucide-react";

const whyUseStoneDiffuser = {
  leftItems: [
    { icon: Gem, title: "Tính thẩm mỹ cao", description: "Tạo điểm nhấn không gian, phù hợp làm quà tặng" },
    { icon: Leaf, title: "Thân thiện với môi trường", description: "Sản xuất từ nguyên liệu tự nhiên, không tiêu tốn năng lượng" },
    { icon: Hand, title: "Dễ dàng sử dụng", description: "Không cần nguồn điện, thao tác đơn giản" },
  ],
  rightItems: [
    { icon: Blend, title: "Tùy biến hương thơm", description: "Kết hợp linh hoạt với nhiều loại tinh dầu" },
    { icon: Package, title: "Nhỏ gọn & tiện lợi", description: "Dễ dàng mang theo và bố trí" },
    { icon: LayoutGrid, title: "Phù hợp đa không gian", description: "Sử dụng linh hoạt từ bàn làm việc đến phòng sinh hoạt" },
  ],
};


const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <Suspense fallback={<div style={{ minHeight: 400 }} />}>
          <AboutSection />
          <FeaturedProducts header="Sản phẩm nổi bật"/>
          <DiffuserStoneIntro />
          <WhyUseSection
              heading="TẠI SAO DÙNG ĐÁ KHUẾCH TÁN TINH DẦU?"
              centerAlt="Đá khuếch tán tinh dầu"
              leftItems={whyUseStoneDiffuser.leftItems}
              rightItems={whyUseStoneDiffuser.rightItems}
              centerImage={centerImage}
          />
          {/*<WhyUseSection*/}
          {/*    heading="TẠI SAO DÙNG TINH DẦU?"*/}
          {/*    centerAlt="Tinh dầu thiên nhiên"*/}
          {/*    leftItems={whyUseEssentialOil.leftItems}*/}
          {/*    rightItems={whyUseEssentialOil.rightItems}*/}
          {/*    centerImage={centerImage_2}*/}
          {/*/>*/}
          <HowToUseSection />
          <FeaturesGrid />
          <BlogSection />
          <TestimonialsSection />
          <CTASection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
